/**
 * Created by Tiger on 03/03/2022.
 */

import cc_zh from "./develop-platform/cc_sdk.md";
import cc_en from "./develop-platform/cc_sdk_en.md";

import dany_specification_zh from "./develop-platform/dany_specification.md";
import dany_specification_en from "./develop-platform/dany_specification_en.md";

import data from "./develop-platform/data.md";

import frog_specification_zh from "./develop-platform/frog_specification.md";
import frog_specification_en from "./develop-platform/frog_specification_en.md";

import oauth_api_zh from "./develop-platform/oauth_api.md";
import oauth_api_en from "./develop-platform/oauth_api_en.md";

import open_api_zh from "./develop-platform/open_api.md";
import open_api_en from "./develop-platform/open_api_en.md";

import pheasant_specification_zh from "./develop-platform/pheasant_specification.md";
import pheasant_specification_en from "./develop-platform/pheasant_specification_en.md";

import platform_manual_zh from "./develop-platform/platform_mannual.md";
import platform_manual_en from "./develop-platform/platform_mannual_en.md";

import snow_specification_zh from "./develop-platform/snow_specification.md";
import snow_specification_en from "./develop-platform/snow_specification_en.md";

import product_specification_zh from "./develop-platform/products_specification.md";
import product_specification_en from "./develop-platform/products_specification_en.md";

import specification_zh from "./develop-platform/specification.md";
import specification_en from "./develop-platform/specification_en.md";

import webhook_zh from "./develop-platform/webhook.md";
import webhook_en from "./develop-platform/webhook_en.md";

import device_privatization_zh from "./device/device_privatization.md";
import device_privatization_en from "./device/device_privatization_en.md";

import lora_mobbus_zh from "./device/lora_modbus.md";
import lora_mobbus_en from "./device/lora_modbus_en.md";

import lora_co2_mobbus_zh from "./device/lora_co2_modbus.md";
import lora_co2_mobbus_en from "./device/lora_co2_modbus_en.md";

import lora_indoor_modbus from "./device/lora_indoor_modbus.md";
import lora_indoor_modbus_en from "./device/lora_indoor_modbus_en.md";

import mqtt_protocol_zh from "./device/mqtt_protocol.md";
import mqtt_protocol_en from "./device/mqtt_protocol_en.md";

import snow_privatization_zh from "./device/snow_privatization.md";
import snow_privatization_en from "./device/snow_privatization_en.md";

const MARKDOWN_DATA = {
  cc_sdk: { zh: cc_zh, en: cc_en },
  dany_specification: { en: dany_specification_en, zh: dany_specification_zh },
  data: { en: data, zh: data },
  frog_specification: { zh: frog_specification_zh, en: frog_specification_en },
  oauth_api: { zh: oauth_api_zh, en: oauth_api_en },
  open_api: { zh: open_api_zh, en: open_api_en },
  pheasant_specification: {
    zh: pheasant_specification_zh,
    en: pheasant_specification_en,
  },
  platform_manual: { zh: platform_manual_zh, en: platform_manual_en },
  snow_specification: { zh: snow_specification_zh, en: snow_specification_en },
  product_specification: {
    zh: product_specification_zh,
    en: product_specification_en,
  },
  specification: { zh: specification_zh, en: specification_en },
  webhook: { zh: webhook_zh, en: webhook_en },
  device_privatization: {
    zh: device_privatization_zh,
    en: device_privatization_en,
  },
  lora_indoor_modbus: { zh: lora_indoor_modbus, en: lora_indoor_modbus_en },
  lora_mobbus: { zh: lora_mobbus_zh, en: lora_mobbus_en },
  lora_mobbus_co: { zh: lora_co2_mobbus_zh, en: lora_co2_mobbus_en },
  mqtt_protocol: { zh: mqtt_protocol_zh, en: mqtt_protocol_en },
  snow_privatization: { zh: snow_privatization_zh, en: snow_privatization_en },
};

export default MARKDOWN_DATA;
